<template>
    <table style = "min-width:360px;">
        <tr class = "open-position__result_row-sub">
            <td class = "open-position__result_row-title-sub">цена</td>
            <td class = "open-position__result_row-title-sub">объем</td>
            <td class = "open-position__result_row-title-sub">p/l, $</td>
            <td class = "open-position__result_row-title-sub">p/l, %</td>
            <td class = "open-position__result_row-title-sub">p/l, p</td>
        </tr>
        <tr class = "open-position__result_row" 
            v-for = "(items, index) in pairData" :key = "index" 
            v-if = "pairData[index].side === sellOrbuy" >
            <td class = "open-position__result_row-data">{{pairData[index].priceEnter}}</td>
            <td class = "open-position__result_row-data">{{pairData[index].volume.toLocaleString('en')}}</td>
            <td class = "open-position__result_row-data"
             :class = "(pairData[index].resultDepo < 0) ? 'color-red' : 'color-green'">{{(pairData[index].resultDepo).toFixed(2)}}</td>
            <td class = "open-position__result_row-data"
                :class="((pairData[index].resultDepo / stat.Summary.Equity * 100) < 0) ? 'color-red' : 'color-green'">{{(pairData[index].resultDepo / stat.Summary.Equity * 100).toFixed(5)}}</td>
            <td class = "open-position__result_row-data"
                :class = "(pairData[index].resultPoint < 0) ? 'color-red' : 'color-green'">{{(pairData[index].resultPoint).toFixed(2)}}</td>
           
        </tr>
    </table>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  props: {
    pairData: { default: [] },
    sellOrbuy: {default: 1}
  },
  computed: {
      ...mapGetters({
                stat: 'accountstat/getPrimaryStatistics',
            }),
        profitLossInPercent()
        {
            let sum = 0;
            for(let i = 0; i < this.pairData.length; i++)
            sum+=this.pairData[i].resultDepo / this.stat.Summary.Equity * 100
            return sum
        }
  },

  methods:{
      getSumPLInPercent()
      {
          let sum = 0;
            for(let i = 0; i < this.pairData.length; i++)
            sum+=this.pairData[i].resultDepo / this.stat.Summary.Equity * 100
          this.$emit('onSumPL', sum)
      }
  },
};
</script>
<style lang="less" scoped>
.open-position {
  &__result {
    padding: 0;

    &_row {
      border-top: solid 1px #374b62;
      padding: 0 8px 0 12px;
      outline: none;
      min-width: 360px;

      &:hover {
        background-color: #506b89;
      }

      &:hover span {
        color: #fff;
      }

      &-sub {
        border-top: solid 1px #374b62;
        padding: 0 8px 0 12px;
        min-width: 360px;
      }

      &-title {
        font-family: Arimo;
        font-size: 10px;
        font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 4;
        letter-spacing: 0.4px;
        color: #aabed2;
        text-transform: uppercase;
        text-align: right;

        &-sub {
          font-family: Arimo;
          font-size: 10px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: 4;
          letter-spacing: 0.4px;
          color: #aabed2;
          text-transform: uppercase;
          text-align: right;

          &:first-child {
            width: 60px;
            text-align: left;
            padding-left: 12px;
          }

          &:nth-child(2) {
            width: 80px;
            text-align: right;
          }

          &:nth-child(3) {
            width: 88px;
            text-align: right;
          }

          &:nth-child(4) {
            text-align: right;
            width: 88px;
          }

          &:nth-child(5) {
            text-align: right;
            width: 80px;
            padding-right: 8px;
          }
        }

        &:first-child {
          min-width: 60px;
          text-align: left;
          padding-left: 12px;
        }

        &:nth-child(2) {
          min-width: 80px;
          text-align: right;
        }

        &:nth-child(3) {
          min-width: 88px;
          text-align: right;
        }

        &:nth-child(4) {
          text-align: right;
          min-width: 88px;
        }
      }

      &-data {
        font-family: Arimo;
        font-size: 13px;
        //font-weight: bold;
        font-style: normal;
        font-stretch: normal;
        line-height: 2.15;
        letter-spacing: 0.4px;
        text-align: left;
        color: #ffffff;

        &-sub {
          font-family: Arimo;
          font-size: 13px;
          font-weight: bold;
          font-style: normal;
          font-stretch: normal;
          line-height: 2.15;
          letter-spacing: 0.4px;
          text-align: right;
          color: #ffffff;

          &:first-child {
            width: 60px;
            text-align: left;
            padding-left: 8px;
          }

          &:nth-child(2) {
            width: 68px;
            text-align: right;
            padding-right: 12px;
          }

          &:nth-child(3) {
            width: 67px;
            text-align: right;
            padding-right: 21px;
          }

          &:nth-child(4) {
            text-align: right;
            width: 31px;
            padding-right: 14px;
          }

          &:nth-child(5) {
            text-align: right;
            width: 31px;
            padding-right: 12px;
          }

          &-ico {
            color: #718da8;
            width: 24px;
            text-align: right;
            padding: 4px;
          }
        }

        &:nth-child(1) {
          width: 60px;
          text-align: left;
          padding-left: 12px;
        }

        &:nth-child(2) {
          text-align: right;
        }

        &:nth-child(3) {
          text-align: right;
        }

        &:nth-child(4) {
          text-align: right;
        }

        &:nth-child(5) {
          text-align: right;
          width: 76px;
          padding-right: 12px;
        }

        &-ico {
          color: #718da8;
          font-size: 24px;
          width: 24px;
          display: block;
          cursor: pointer;

          &-sub {
            color: #718da8;
            font-size: 18x;
            width: 24px;
            display: block;
            text-align: center;
            padding-top: 3px;

            &:hover {
              color: #fff;
            }
          }
        }
      }
    }
  }
}
</style>
